<template>
  <div class="fixed" style="top: -9999px; left: -9999px">
    <!-- Place here classes that could possibly be generated by js (concatination) in order for tailwind to recognise them properly -->
    <span class="text-white bg-white"></span>
    <span class="text-concrete bg-concrete"></span>
    <span class="text-platinum bg-platinum"></span>
    <span class="text-silver bg-silver"></span>
    <span class="text-gray bg-gray"></span>
    <span class="text-granite bg-granite"></span>
    <span class="text-black bg-black"></span>
    <span class="text-yellow bg-yellow"></span>
    <span class="text-blue bg-blue"></span>
    <span class="text-green bg-green"></span>
    <span class="text-lightgreen bg-lightgreen"></span>
    <span class="text-orange bg-orange"></span>
    <span class="text-purple bg-purple text-white/50"></span>
    <span class="text-red bg-red text-black/50"></span>
  </div>
</template>

<script>
  export default {
    name: 'classes-polyfill'
  }
</script>
